import { getLocaleFromPath, buildLocalePath } from "./locale-utils";
import type { SupportedLanguage } from "../i18n";

/**
 * Returns a function that builds a locale-prefixed path using the current URL locale.
 * Useful for <a href> links that should preserve the user's current locale.
 */
export function useLocalePath() {
  const locale = getLocaleFromPath(window.location.pathname);
  return (basePath: string) => buildLocalePath(locale as SupportedLanguage, basePath);
}
